<div class="w-full">
    <div class="grid gap-4 lg:gap-12 w-full " [ngClass]="isHomePage 
         ? 'grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3' 
         : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3' ">

        <ng-container *ngFor="let item of sanitizedItems">
            <a *ngIf="isHomePage" [routerLink]="['/auctions', auctionId, 'items', item.id]"
                class="block bg-white shadow-md rounded-lg p-3 max-w-lg mx-auto transition-transform overflow-hidden"
                [ngClass]="{ 'scale-90': isHomePage }" [ngStyle]="{ 'max-width': '80%', 'width': '100%' }"
                style="display: flex; flex-direction: column; height: 500px;">
                <ng-container *ngTemplateOutlet="cardContent; context: { item: item }"></ng-container>
            </a>

            <a *ngIf="!isHomePage" class="bg-white shadow-md rounded-lg p-3 max-w-lg mx-auto transition-transform overflow-hidden"
                [ngClass]="{ 'scale-100': !isHomePage }" [ngStyle]="{ 'max-width': '300px', 'width': 'auto' }"
                style="display: flex; flex-direction: column; height: 500px; cursor: pointer;"
                (click)="onOpenModalVertical(item.id!)">
                <ng-container *ngTemplateOutlet="cardContent; context: { item: item }"></ng-container>
            </a>
        </ng-container>

        <ng-template #cardContent let-item="item">
            <div class="relative flex justify-center items-center h-[220px]">
                <div class="flex justify-center items-center w-full h-full">
                    <img *ngIf="!item.imageUrl.includes('item-default.jpg')" [src]="item.imageUrl" [alt]="item.name" class="object-contain w-full h-full rounded transition-all" />
                    <app-default-image *ngIf="item.imageUrl.includes('item-default.jpg')" [element]="'imageListV'"></app-default-image>
                </div> 
                <div class="absolute top-0 left-0 w-full h-full flex items-start"
                    [ngClass]="{ 'top-0 left-0': isHomePage }">
                    <span
                        class="absolute top-0 left-0 bg-white px-3 py-0.5 text-[12px] font-mulish rounded-[10px] text-[#4A4A4A]"
                        style="box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.3);">
                        {{ item.lotNumber }}
                    </span>
                </div>
            </div>

            <div class="p-3 w-full flex flex-col h-full">
                <h3 class="text-xl font-semibold text-[var(--p-info-500)] line-clamp-2" [innerHTML]="item.safeName"></h3>

                @if (item.isBiddable || item.isBuyable) {
                <p class="text-gray-700">
                    <span class="text-lg font-bold text-custom-black">
                        {{ item.currentLeadingBid ? item.currentLeadingBid : item.buyNowPrice }}
                    </span>
                    <span class="text-[var(--p-primary-500)] text-md font-semibold ml-2">
                        {{ item.isBiddable ? (item.numberOfBids === 0 ? 'Opening Bid' : 'Leading Bid') : 'Buy Now' }}
                    </span>
                </p>
                }

                <p>
                    <span *ngIf="item.estimatedValue; else noEstimatedValue" class="text-[#6E6E6E] text-sm">
                        {{ isAmountEstimatedValue(item.estimatedValue) ? item.estimatedValue + ' Estimated Value' :
                        'Priceless' }}
                    </span>
                    <ng-template #noEstimatedValue>
                        <span class="text-gray-500 text-xs invisible">-</span>
                    </ng-template>
                </p>

                <div class="mt-auto">
                    <button pButton class="!bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)] rounded-lg w-full" [rounded]="true">
                        <span class="pi pi-credit-card !text-[var(--p-text-color-secondary)] text-xs"></span>
                        <span class="!text-[var(--p-text-color-secondary)] font-mulish text-xs md:text-sm font-semibold whitespace-nowrap">
                            @if (item.isBiddable) {
                            <span>Place a Bid</span>
                            } @else if (item.isBuyable) {
                            <span>Buy Now</span>
                            } @else {
                            <span>See More</span>
                            }
                        </span>
                    </button>
                </div>

                <div class="text-center mt-2">
                    <p class="h-5 font-mulish font-medium text-sm italic text-[#4A4A4A]">
                        {{ timeLeftService.getTimeLeft(item.openingDate, item.closingDate) }}
                    </p>
                </div>
            </div>
        </ng-template>

    </div>